import { render } from "./FoalMainData.vue?vue&type=template&id=d707fbde"
import script from "./FoalMainData.vue?vue&type=script&lang=js"
export * from "./FoalMainData.vue?vue&type=script&lang=js"

import "./FoalMainData.vue?vue&type=style&index=0&id=d707fbde&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__